export default __webpack_public_path__ + "static/floor1-slide-1-6ab9278b36bef0838c4380f6d3f03c7d.jpg";